import { useJsDataContext } from '@bingads-webui-cc-react/js-data-rest';

export const useAccountData = ({
  scope,
}) => {
  const ccJsData = useJsDataContext();

  return {
    getAccount: () => ccJsData.Account.find(scope.values.aid),
  };
};
